module.exports = __webpack_public_path__ + "img/AS.e46b65c0.svg";